import styled from "styled-components"
import { Tooltip } from "primereact/tooltip"

const StyledTooltip = styled(Tooltip)``

export default StyledTooltip
